__turbopack_context__.v({
  "section-goal-year": "dfrALq_section-goal-year",
  "section-goal-year__animation--desktop": "dfrALq_section-goal-year__animation--desktop",
  "section-goal-year__animation--mobile": "dfrALq_section-goal-year__animation--mobile",
});
